import { Event } from '@/feature/event-details-sbk/types';
import { TeamOrder } from '@/utils/sport-utils';

import { MatchupCardLayout } from './MatchupCardLayout';
import { TeamInfoRow } from './parts/TeamInfoRow';
import { useIsMatchupLive } from './use-is-matchup-live';
import { useMatchupTeamRows } from './use-matchup-team-rows';
import { MarketColumn } from './utils';

type DefaultMatchupCardProps = {
    event: Event;
    marketColumns: MarketColumn[];
    totalRows: number;
    teamOrder: TeamOrder;
    showHeader?: boolean;
    isLastItem?: boolean;
    onPress?: () => void;
};

// Default dynamic card for 2-way team sports (basketball, football, hockey, baseball).
export const DefaultMatchupCard = ({
    event,
    marketColumns,
    totalRows,
    teamOrder,
    showHeader,
    isLastItem,
    onPress,
}: DefaultMatchupCardProps) => {
    const isLive = useIsMatchupLive(event);
    const hasFootballIcon = isLive && event.sport.name === 'American Football';
    const teamInfoRows = useMatchupTeamRows(event, teamOrder);

    return (
        <MatchupCardLayout
            event={event}
            marketColumns={marketColumns}
            totalRows={totalRows}
            teamOrder={teamOrder}
            showHeader={showHeader}
            isLastItem={isLastItem}
            onPress={onPress}
        >
            {teamInfoRows.map(teamInfo => (
                <TeamInfoRow
                    key={teamInfo.side}
                    {...teamInfo}
                    event={event}
                    hasFootballIcon={hasFootballIcon}
                    isLive={isLive}
                />
            ))}
        </MatchupCardLayout>
    );
};
